module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pn_layer_on-292f35054f5a279b52851453aa266d6b.jpg";